module.exports = __webpack_public_path__ + "img/79.2b877d5b.jpg";